import PropTypes from 'prop-types'
import React from 'react'
import { Box, useStyleConfig } from '@chakra-ui/react'

function Card(props) {
  const { variant, borderType, children, ...rest } = props
  const styles = useStyleConfig('Card', { variant, borderType })

  return (
    <Box __css={styles} minW="270px" {...rest}>
      {children}
    </Box>
  )
}

Card.propTypes = {
  borderType: PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.string,
}

export default Card
